import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { FullNameComponent } from 'src/app/shared/full-name/full-name.component';
import { DateOfBirthComponent } from 'src/app/shared/date-of-birth/date-of-birth.component';
import { RelationshipComponent } from 'src/app/shared/relationship/relationship.component';
import { PhoneNumberComponent } from 'src/app/shared/phone-number/phone-number.component';
import { EmailAddressComponent } from 'src/app/shared/email-address/email-address.component';
import { ProgressBarService } from '../../../core/progress-bar.service';
import { StoreService } from '../../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Guardian } from '../shared/guardian.model';

@Component({
  selector: 'first-guardian',
  templateUrl: './first-guardian.component.html',
})
export class FirstGuardianComponent {
  @ViewChild(FullNameComponent) fullNameComponent: FullNameComponent;
  @ViewChild(DateOfBirthComponent) dateOfBirthComponent: DateOfBirthComponent;
  @ViewChild(RelationshipComponent) relationshipComponent: RelationshipComponent;
  @ViewChild(PhoneNumberComponent) phoneNumberComponent: PhoneNumberComponent;
  @ViewChild(EmailAddressComponent) emailAddressComponent: EmailAddressComponent;

  title = 'firstGuardian.title';
  progressBar = this.progress.firstGuardian;
  relationships: Array<string> = this.store.state.guardianRelationships;
  firstGuardian: Guardian = {
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: null,
    relationship: '',
    phoneNumber: '',
    email: ''
  }

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  isGuardianEmpty(): boolean {
    if (this.firstGuardian.firstName
      || this.firstGuardian.lastName
      || this.firstGuardian.dateOfBirth
      || this.firstGuardian.relationship
      || this.firstGuardian.phoneNumber
      || this.firstGuardian.email) {
      return false;
    } else
      return true;
  }

  disabled(): boolean {
    return this.fullNameComponent.form.valid
      && this.dateOfBirthComponent.form.valid
      && this.relationshipComponent.form.valid
      && this.phoneNumberComponent.form.valid
      && this.emailAddressComponent.form.valid;
  }

  back() {
    this.router.navigate([this.navigation.firstGuardian.back]);
  }

  next() {
    if (!this.isGuardianEmpty()) {
      this.store.addPotentialRepresentative(this.firstGuardian);
      this.store.state.consent.guardians[0] = this.firstGuardian;
    }
    this.router.navigate([this.navigation.firstGuardian.next]);
  }

}
